import { CommonModule } from '@angular/common';
import { Component, HostBinding, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface TooltipConfig {
  maxWidth?: string;
  allowHtml?: boolean;
  tooltipClass?: string | string[];
}

@Component({
  selector: 'tooltip-drawer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tooltip-drawer.component.html',
  styleUrls: ['./tooltip-drawer.component.scss']
})
export class TooltipDrawerComponent {
  @ViewChild('vc', { read: ViewContainerRef, static: true })
  vc!: ViewContainerRef;
  config: TooltipConfig = {};
  isComponent = false;
  renderedContent: SafeHtml | string = '';

  @HostBinding('style.max-width')
  get maxWidthStyle() {
    return this.config?.maxWidth ?? null;
  }

  constructor(private sanitizer: DomSanitizer) { }

  attachContent(content: any, data?: any) {
    if (this.isComponentType(content)) {
      this.isComponent = true;
      this.vc.clear();
      const ref = this.vc.createComponent<any>(content);
      if (data) Object.assign(ref.instance, data);
      return;
    }
    this.isComponent = false;
    this.renderedContent = this.config.allowHtml ? this.sanitize(content) : content;
  }

  private isComponentType(content: any): boolean {
    return typeof content === 'function';
  }

  private sanitize(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  setConfig(config: TooltipConfig) {
    this.config = config;
  }
}
